/**
 * Calcula o valor das parcelas com juros compostos
 * @param {number} amount - Valor a ser financiado
 * @param {number} months - Número de meses para pagamento
 * @param {number} rate - Taxa de juros mensal (em percentual)
 * @returns {number} - Valor da parcela mensal
 */
export const calculateInstallments = (amount, months, rate) => {
    // Converter a taxa de percentual para decimal
    const monthlyRate = rate / 100;

    // Fórmula de juros compostos para cálculo de parcelas
    if (monthlyRate === 0) {
        return amount / months;
    }

    const installment =
        amount * (monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);

    return Math.round(installment * 100) / 100;
};

/**
 * Formata um valor numérico para o formato de moeda brasileira
 * @param {number} value - Valor a ser formatado
 * @returns {string} - Valor formatado como moeda
 */
export const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};

/**
 * Calcula o desconto baseado em um valor e percentual
 * @param {number} value - Valor original
 * @param {number} percentage - Percentual de desconto
 * @returns {number} - Valor do desconto
 */
export const calculateDiscount = (value, percentage) => {
    return (value * percentage) / 100;
};

/**
 * Calcula o preço final após aplicar um desconto
 * @param {number} originalValue - Valor original
 * @param {number} discountPercentage - Percentual de desconto
 * @returns {number} - Valor final após desconto
 */
export const calculateFinalPrice = (originalValue, discountPercentage) => {
    const discount = calculateDiscount(originalValue, discountPercentage);
    return originalValue - discount;
};